import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteService } from "../../api/apiServices";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف خدمة (soft delete)
 */
export function useDeleteService() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteServiceMutate,
        isPending,
    } = useMutation({
        mutationFn: deleteService,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete service");
        },
    });

    return {
        deleteServiceMutate,
        isPending,
    };
}